
@if (!mapEnabled) {
    <p>
    <button nz-button nzType="default" (click)="enableMap()">{{ 'app.lib.common.show' | actrans }} {{ 'app.lib.common.map' | actrans:{lowercase: true} }}</button>
    </p>
} @else {
    <div id="google-map-div"></div>
}
